import React from "react";
import NavigationDrawer from "./../../../components/NavigationDrawer/index";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import { Grid } from "@mui/material";
import AllStudentsReports from "./AllStudentsReports";
import AllReportCards from "./AllReportCards";
import ReportCardDetail from "./ReportCardDetail";
import ReportCardTemplate from "./ReportCardTemplate";

const tabs = [
  { label: "Generate Cards", value: "ed_generate_card" },
  { label: "Report Cards", value: "ed_report_card" },
  // { label: "Report Card Template", value: "ed_report_card_template" },
  // { label: "ID Card Templates", value: "ed_id_card_template" },
];

const EducationReportCard = () => {
  const dispatch = useDispatch();
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  // Function

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, education_report_card: tab }));
  };
  return (
    <NavigationDrawer>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"Reports & Cards*"}
            tabs={tabs}
            activeTab={activeTab.education_report_card}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.education_report_card === "ed_generate_card" ? (
            <AllStudentsReports />
          ) : activeTab.education_report_card === "ed_report_card" ? (
            <AllReportCards />
          ) : activeTab.education_report_card === "ed_report_card_detail" ? (
            <ReportCardDetail />
          ) : activeTab.education_report_card === "ed_report_card_template" ? (
            <ReportCardTemplate />
          ) : null}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
};

export default EducationReportCard;
